import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import "./Advertisement.css";

import Food_ContainerImg from "../../asset/images/advertisement/Rectangular Container.jpg";
import LaundryItemImg from "../../asset/images/advertisement/Laundry Busket.jpg";
import fittingsImg from "../../asset/images/advertisement/fittings.jpg";
import jugImg from "../../asset/images/advertisement/jug.jpg";
import household1 from "../../asset/images/advertisement/household1.jpg";
import household2 from "../../asset/images/advertisement/household2.jpg";
import square_rack from "../../asset/images/advertisement/Squre Rack.jpg";
import chairImg from "../../asset/images/advertisement/President Chair.jpg";
import pipe1Img from "../../asset/images/advertisement/pipe1.jpg";
import threadPipeImg from "../../asset/images/advertisement/threadPipe.jpg";
import bucketImg from "../../asset/images/advertisement/bucketposter.jpg";
import tableImg from "../../asset/images/advertisement/04.jpg";
import AOS from "aos";
import Spinner from "../Spinner/Spinner"; 

import { Modal } from 'react-bootstrap';

const Advertisement = () => {
  useEffect(() => {
    AOS.init({
      offset: 120,
      delay: 0,
      easing: "ease",
      duration: 1000,
      disable: false,
      once: false, 
      mirror: false,
      startEvent: "DOMContentLoaded",
      animatedClassName: "aos-animate",
      initClassName: "aos-init",
      useClassNames: false,
    });
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const [show, setShow] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const handleShow = (videoId) => {
    setActiveVideo(videoId);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setActiveVideo(null);
  }; 
 

  return ( 
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Container style={{ marginTop: "3rem", marginBottom: "8rem" }}>
          <Row
            data-aos="fade-down"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="1000"
            style={{ marginTop: "5rem" }}
          >


{/* from 1 */}

      {/* <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                   // height: "100%",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
                  // poster={bucketImg}
                >
                  <source src={ad1} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Waredrobe</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
                //  poster={bucketImg}
                >
                  <source src={ad2} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
              //    poster={bucketImg}
                >
                  <source src={ad3} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
              //    poster={bucketImg}
                >
                  <source src={ad4} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }} 
             //     poster={bucketImg}
                >
                  <source src={ad5} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
               //   poster={bucketImg}
                >
                  <source src={ad6} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Kitchen Rack</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
               //   poster={bucketImg}
                >
                  <source src={ad7} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Waredrobe</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
               //   poster={bucketImg}
                >
                  <source src={ad8} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Plastic Items</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
               //   poster={bucketImg}
                >
                  <source src={ad9} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
              //    poster={bucketImg}
                >
                  <source src={ad10} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Container</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
             //     poster={bucketImg}
                >
                  <source src={ad11} type="video/mp4" /> 
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>
  
            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    maxWidth: "100%",
                  }}
               //   poster={bucketImg}
                >
                  <source src={ad12} type="video/mp4" /> 
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Waredrobe</h2>
                </Card.Body>
              </Card> 
            </Col>
   
            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%", 
                    height: "280px", 
                    objectFit: "contain", 
                    maxWidth: "100%",
                  }}
                 // poster={bucketImg}
                >
                  <source src={ad13} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Master Bike</h2>
                </Card.Body>
              </Card>
            </Col>


            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={bucketImg}
                >
                  <source src={AllBucket} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Bucket</h2>
                </Card.Body>
              </Card>
            </Col>


         

<Col lg={4} md={6} sm={12}>
  <Card className="serviceCard">
    <div
      style={{
        width: "100%",
        height: "280px",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/i609Leyuv1M?si=k25pRu3nXGU0k87A"
        title="Dinning Table"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ objectFit: "cover" }}
      ></iframe>
    </div>

    <Card.Body className="text-center">
      <h2 className="servicesCardTitle">Dinning Table</h2>
    </Card.Body>
  </Card>
</Col>


            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={fittingsImg}
                >
                  <source src={Fittings_Advertise} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Fittings Advertise</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={Food_ContainerImg}
                >
                  <source src={Food_Container} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Food Container</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={household1}
                >
                  <source src={Household_Product1} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Household Product one</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={household2}
                >
                  <source src={Household_Product2} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Household Product two</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={jugImg}
                >
                  <source src={Jug_Advertise} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Jug Advertise</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={chairImg}
                >
                  <source src={King_Chair_Advertise} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">King Chair</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={LaundryItemImg}
                >
                  <source src={Lundry_Basket_Advertise} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Laundry Basket</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={square_rack}
                >
                  <source src={Rack_Advertise} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle">Rack Advertise</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={pipe1Img}
                >
                  <source src={Pipe_Advertise_2} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle"> Pipe Advertise </h2>
                </Card.Body>
              </Card>
            </Col>
   
            <Col lg={4} md={6} sm={12}>
              <Card className="serviceCard">
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  poster={threadPipeImg}
                >
                  <source src={Thread_Pipe} type="video/mp4" />
                </video>
                <Card.Body className="text-center">
                  <h2 className="servicesCardTitle"> Thread Pipe</h2>
                </Card.Body>
              </Card>
            </Col> */} 
 
    

{videoAd.map((item) => (
      <Col key={item.id} lg={4} md={6} sm={12} className="mb-4">
        <div
          className="portfolio-item" 
          style={{
            width: "100%",
            height: "320px",
            overflow: "hidden",
            borderRadius: "8px",
            position: "relative",
          }}
        > 
          <p>{item.name}</p> 
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${item.src}`} // Make sure item.videoUrl is dynamic
            title={item.name || "YouTube Video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </Col>
    ))}
            
          </Row>
        </Container>
      )}
    </>
  );
};

export default Advertisement;

const videoAd =[

  {
    id: 30,
    src: 'nEFE0SLUPXo?si=OZH39a2yghscqKCZ'
  },
  {
    id: 1,
    src: 'iN5UXrBtykM?si=R6ud0c0VhHU5kEcC'
  },
  {
    id: 2,
    src: 'KX0r_GHQdtU?si=-bvulTmuNMQznMNI'
  },
  {
    id: 3,
    src: 't_-V6L432oQ?si=oKUwWw4cclYjYiuo'
  },
  {
    id: 4,
    src: 'G4jL5Kp2jjs?si=U89Zl38UHX4pRqGh'
  },
  {
    id: 5,
    src: 'dtBSX1LLmao?si=6ZwY5-Op6UC3kQoU'
  },
  {
    id: 6,
    src: '3nVSavOEp88?si=q-hzmlL2QzaeC0w2'
  },

    {
    id: 21,
    src: 'jFy3kNYd6X8?si=8EnjWyUb-db7XLH8'
  },
  {
    id: 22,
    src: 'idbukbHG0mU?si=O6gHM_ZU7uXeV9Tn'
  },
  {
    id: 23,
    src: 'T5xrhrQe0OE?si=Rde3FB39lH6aJtiH'
  },
  {
    id: 24,
    src: 'CGSM_figTZo?si=Adu4D5o5dAzQWwjN'
  },
  {
    id: 25,
    src: 'QTFFDuV9v8E?si=8mBAr3gn_maXP5o1'
  },

  {
    id: 7,
    src: 'i609Leyuv1M?si=r9Z3QU-dgldxAYjp'
  },
  {
    id: 8,
    src: 'a9uR3qgH_r4?si=q8ThP0rO6oI-f3N4'
  },
  {
    id: 9,
    src: 'KzuOEXT9fxo?si=UzwlNldujSl7ud0Y'
  },
  {
    id: 10,
    src: 'UP1G5477qL0?si=u4omVpxfNpe5DJLh'
  },
  {
    id: 11,
    src: 'U5Ptt9P3Dsw?si=85FB4zpgp7xsXRyl'
  },
  {
    id: 12,
    src: 'n5BxEQHDZwY?si=xWuRIsFiBcn_1vqC'
  },
  {
    id: 13,
    src: 'l7hPStDygYY?si=YVxpBWaYaQfdMmBS'
  },
  {
    id: 14,
    src: 'q4HqWSIM7k4?si=b2X-HxQla1CUZ2VX' 
  },
  {
    id: 15,
    src: '4sALdZuZA8w?si=Kuc6eJg1JMDoqPnE'
  },
  {
    id: 16,
    src: 'KasjV3p7I7M?si=C6TJA9tdar8YcmQO'
  },
  {
    id: 17,
    src: 'DSD-uGXinFU?si=wO4ZT9PskkBRhF8n'
  },
  {
    id: 18,
    src: 'JuOUu7lhVMM?si=TDfZtKuXH4kNnwvg'
  },
  {
    id: 19,
    src: 'H6t2Z0-UZmc?si=HlaS59aJ2KUsvkIg'
  },
  {
    id: 20,
    src: '7XoOQLLcd7g?si=x48Cm3pH9XlfNpcq'
  },
  
]

